// extracted by mini-css-extract-plugin
module.exports = {"milestoneContainer":"MilestoneContainer_milestoneContainer___ckGk","title":"MilestoneContainer_title__39Abd"};